import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const fleetErrorAPI = {
	getFleetErrors: (request: GlobalFleetErrorsRequest) => {
		return axios
			.get(`${apiUrl}/global/fleet-errors`)
			.then((response) => response.data as FleetErrorDTO[]);
	},
	getFleetError: (request: GlobalFleetErrorRequest) => {
		return axios
			.get(`${apiUrl}/global/fleet-errors/${request.fleetErrorId}`)
			.then((response) => response.data as FleetErrorDTO);
	},
	getFleetErrorCounts: () => {
		return axios
			.get(`${apiUrl}/global/fleet-errors-counts/`)
			.then((response) => response.data as FleetErrorCountsDTO[]);
	},
	updateFleetError: (request: UpsertFleetErrorRequest) => {
		const fleetError = request;
		return axios
			.post(`${apiUrl}/global/fleet-errors`, fleetError)
			.then((response) => response.data as FleetErrorDTO);
	},

	// client site methods
	getClientSiteFleetErrors: (request: ClientSiteGlobalFleetErrorsForCoreTestRequest) => {
		return axios
			.get(`${clientApiUrl}/datasets/${request.datasetId}/global/fleet-errors/${request.coreTestResultId}`)
			.then((response) => response.data as FleetErrorDTO[]);
	},
};

export default fleetErrorAPI;
